import { Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router";

import { GUFEvent } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { useRouterTableData } from "@/hooks/use-router-table-data";
import { useGufEventListQuery } from "@/queries/query-guf";

import { GUF_EVENT_NAME_TO_SLUG } from "../../../../../helpers/convert-guf-event-to-task";

const gufEventInformation: { key: keyof GUFEvent; label: string }[] = [
  { key: "eventName", label: "Gebeurtenis" },
  { key: "eventDate", label: "Datum" },
];

const getEditUrl = (event: GUFEvent): string | undefined => {
  const slug = GUF_EVENT_NAME_TO_SLUG[event.eventName];
  if (!slug || !event.uuid) return undefined;
  return `/guf/${slug}/${event.uuid}/`;
};

const GufEventTable: React.FC<{ uuid: string }> = ({ uuid }) => {
  const navigate = useNavigate();
  const { page, setPage } = useRouterTableData({ hasSearchParams: false });
  const { data: eventList, isLoading } = useGufEventListQuery({ guf: uuid, page });
  const paginationProps = useQueryPagination({ queryResponse: eventList, page, setPage });

  const columnDefinitions: ColumnDefinition<GUFEvent>[] = gufEventInformation.map(
    ({ key, label }, index) => ({
      title: label,
      renderFunction: (row: GUFEvent) => {
        if (index === 0) {
          const url = getEditUrl(row);
          if (url) {
            return (
              <Text
                color="primary"
                cursor="pointer"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                onClick={() => navigate(url)}
              >
                {String(row[key])}
              </Text>
            );
          }
        }
        return renderDefault(row[key]);
      },
      width: "1fr",
    })
  );

  // Should remove events with event_name = startRegistratie
  const filteredEvents = eventList?.results?.filter(
    (event) => event.eventName !== "startRegistratie"
  );

  return (
    <TableOverview
      themeColor="#7eb8a0"
      isLoading={isLoading}
      tableData={filteredEvents ?? []}
      columnDefinitions={columnDefinitions}
      paginationProps={paginationProps}
    />
  );
};

export { GufEventTable };
